<template>
  <div id="home">
      <PageLoader />
      <NavBar />
      <HeaderBar />
      <SliderWrapper />
      <IndexModal />
      <JobsWrapper /> 
      <CompaniesWrapper />
      <StatsWrapper />
      <HowItWorks />
      <MobileApp />
      <PricingWrapper />
      <TestimonialsWrapper />
      <BlogWrapper />
      <ContactsWrapper />
      <ClientsWrapper />
      <FooterWrapper />
      <LoginPopup />
      <RegisterPopup />
  </div>
</template>

<script>
import IndexModal from '@/components/IndexModal.vue'
import PageLoader from '@/components/PageLoader.vue'
import NavBar from '@/components/NavBar.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import SliderWrapper from '@/components/SliderWrapper.vue'
import JobsWrapper from "@/components/JobsWrapper.vue"
import CompaniesWrapper from "@/components/CompaniesWrapper.vue"
import StatsWrapper from '@/components/StatsWrapper.vue'
import HowItWorks from '@/components/HowItWorks.vue'
import MobileApp from '@/components/MobileApp.vue'
import PricingWrapper from '@/components/PricingWrapper.vue'
import TestimonialsWrapper from '@/components/TestimonialsWrapper.vue'
import BlogWrapper from '@/components/BlogWrapper.vue'
import ContactsWrapper from '@/components/ContactsWrapper.vue'
import ClientsWrapper from '@/components/ClientsWrapper.vue'
import FooterWrapper from '@/components/FooterWrapper.vue'
import LoginPopup from '@/components/LoginPopup.vue'
import RegisterPopup from "@/components/RegisterPopup.vue"
export default {
    components: {
        PageLoader,
        NavBar,
        HeaderBar,
        SliderWrapper,
        IndexModal,
        JobsWrapper,
        CompaniesWrapper,
        StatsWrapper,
        HowItWorks,
        MobileApp,
        PricingWrapper,
        TestimonialsWrapper,
        BlogWrapper,
        ContactsWrapper,
        ClientsWrapper,
        FooterWrapper,
        LoginPopup,
        RegisterPopup
    },
    created(){
      
        let jsSettingsTag = document.createElement('script');  
        jsSettingsTag.setAttribute('src',"js/settings.js");
        document.body.appendChild(jsSettingsTag);
        
      
    }    
}
</script>

<style>

</style>